import { history } from '@umijs/max';
import { iBoxBridge, IBOX_BROWSER_ACTION_ENUM } from 'izen-common-utils';
export function isApp() {
  return (
    !!~navigator.userAgent.toLowerCase().indexOf('ibox_app') ||
    !!~navigator.userAgent.toLowerCase().indexOf('izen_app')
  );
}

// 20000007 类型
export enum refreshType {
  myNativePage = 1, //我的持仓
}
// 20000006 类型
export enum OFF_TYPE {
  /**默认跳转*/
  TU_NAME = 1,
  /**关闭当前页面跳转到新的页面*/
  OFF_LINE,
  /**关闭所有页面*/
  OFF_LINE_ALL,
}

export const getAppDistanceTop = () => {
  let height = 0;
  if (isApp()) {
    iBoxBridge.jsCallNative({
      action: IBOX_BROWSER_ACTION_ENUM.GetHeaderBarHeight,
      data: {},
      callback: (response) => {
        if (response && response.data) {
          height = response.data;
        }
      },
    });
  }
  return height;
};

export const setAppDistance = (code: IBOX_BROWSER_ACTION_ENUM) => {
  if (isApp()) {
    iBoxBridge.jsCallNative({
      action: code,
      data: {},
      callback: (response) => {
        console.log(response);
      },
    });
  }
};

export const AppUtil = {
  async initAppInfo() {
    if (!isApp()) return;
    if (
      Number(window.localStorage.getItem('header_safe_distance') || '0') < 1
    ) {
      const top = await AppUtil.getHeaderBarHeight();
      window.localStorage.setItem('header_safe_distance', top + '');
    }
    if (!window.localStorage.getItem('BottomSafeDistance')) {
      const bottom = await AppUtil.getFooterBarHeight();
      window.localStorage.setItem('BottomSafeDistance', bottom + '');
    }
  },
  async getUserInfoData() {
    if (isApp()) {
      const res: any = await AppUtil.GetUserInfo();
      if (res?.userInfo) {
        window.localStorage.setItem('userInfo', JSON.stringify(res?.userInfo));
      }
      return res?.userInfo;
    }
    return JSON.parse(window.localStorage.getItem('userInfo') || '{}');
  },
  backClose(data?: { result?: boolean }) {
    if (isApp()) {
      AppUtil.closePage(data);
    } else {
      history.back();
    }
  },
  openUrl(url: string, offType: number = OFF_TYPE.TU_NAME) {
    if (isApp()) {
      AppUtil.openView({
        url: url,
        offType: offType,
      });
    } else {
      location.href = url;
    }
  },
  openViewAndCloseWebView(url: string) {
    if (isApp()) {
      AppUtil.OpenViewAndClosePrevPage({
        url: url,
      });
    } else {
      location.href = url;
    }
  },
  callShare(data: {
    type: number; //0、1、2、 (0，微信、1 朋友圈、2 保存图片),
    title?: string;
    content?: string;
    url?: string;
    base64Img?: string;
  }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.ShareChannel,
        data,
      });
      resolve();
    });
  },
  goAddress() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GoAddress,
      });
      resolve();
    });
  },
  goCreator(uid: number) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.HIBActionOpenCreator,
        data: { uid },
      });
      resolve();
    });
  },
  goBrand(brandId: number) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.HIBActionOpenBrandPage,
        data: { brandId },
      });
      resolve();
    });
  },
  doSDKAuthentication(data?: { certifyId?: string; bizType?: string }) {
    return new Promise<any>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.DoAuthentication,
        data,
        callback: (response) => {
          resolve(response);
        },
      });
    });
  },
  goIdentity() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GoIdentity,
      });
      resolve();
    });
  },
  login(data?: { phone?: string | number }) {
    return new Promise(() => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.Login,
        data,
        callback: () => {
          location.reload();
        },
      });
    });
  },
  checkToken(data?: {
    isOpenLogin?: boolean; // 控制是否自动跳转登录
  }) {
    return new Promise((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.CheckToken,
        data,
        callback: (response) => {
          resolve(response || {});
        },
      });
    });
  },
  goodsResell(data: any) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GoodsResellSuccess,
        data,
      });
      resolve();
    });
  },
  mboxResell(data: any) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.MboxResellSuccess,
        data,
      });
      resolve();
    });
  },
  goAccount() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.BackPersonCenter,
      });
      resolve();
    });
  },
  goAlbumDetail(data: {
    aid: number; // 专辑id
    gid?: number; // 商品id
  }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GoodsDetail,
        data,
      });
      resolve();
    });
  },
  closePage(data?: { result?: boolean }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.ClosePage,
        data,
      });
      resolve();
    });
  },
  getFooterBarHeight() {
    if (window.localStorage.getItem('BottomSafeDistance')) {
      return window.localStorage.getItem('BottomSafeDistance');
    }
    if (isApp()) {
      return new Promise((resolve) => {
        iBoxBridge.jsCallNative({
          //@ts-ignore
          action: '20000013',
          callback: (data) => {
            resolve(data?.navigationBarHeight || 10);
          },
        });
      });
    }
  },
  getHeaderBarHeight() {
    if (
      window.localStorage.getItem('header_safe_distance') &&
      Number(window.localStorage.getItem('header_safe_distance'))
    ) {
      return window.localStorage.getItem('header_safe_distance');
    }
    return new Promise((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GetHeaderBarHeight,
        callback: (data) => {
          resolve(data?.statusBarHeight || 0);
        },
      });
    });
  },
  setHeaderBar(data: {
    statusBarStyle: number; // (0 默认黑色、1 白色)
  }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.SetHeaderBar,
        data,
      });
      resolve();
    });
  },
  logoff() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 注销账户
        action: IBOX_BROWSER_ACTION_ENUM.Logoff,
      });
      resolve();
    });
  },
  linkOutApp(data: {
    type: number;
    appSchemeUrl: string;
    appDownloadUrl: string;
  }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 跳转外部app
        action: IBOX_BROWSER_ACTION_ENUM.LinkOutApp,
        data,
      });
      resolve();
    });
  },
  linkWxProgram(data: { wxProgramId: string; path?: string }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 跳转微信小程序
        action: IBOX_BROWSER_ACTION_ENUM.LinkWxProgram,
        data,
      });
      resolve();
    });
  },
  openView(data: { url: string; offType?: number }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 跳转webview或者app页面
        action: IBOX_BROWSER_ACTION_ENUM.OpenView,
        data,
      });
      resolve();
    });
  },
  getAppInfo() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 获取app信息
        action: IBOX_BROWSER_ACTION_ENUM.GetAppInfo,
        callback: (data) => {
          resolve(data);
        },
      });
    });
  },
  // 刷新上个Native页面的接口
  refreshPreNativePage(type: number) {
    return new Promise<void>(() => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 获取app信息
        action: IBOX_BROWSER_ACTION_ENUM.refresPreNativePage,
        data: {
          type,
        },
      });
    });
  },
  // 跳转新页面 & 关闭当前webview
  OpenViewAndClosePrevPage(data: { url: string }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.OpenViewAndClosePrevPage,
        data,
      });
      resolve();
    });
  },
  // 获取用户信息
  GetUserInfo() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '10000018',
        callback: (data) => {
          resolve(data);
        },
      });
    });
  },
  // 获取阿里人脸识别SDK环境参数
  doSDKAuthenticationCode() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000010',
        callback: (data) => {
          resolve(data);
        },
      });
    });
  },
  // 退出登陆
  LogOut() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000011',
      });
      resolve();
    });
  },
  // 去掉iOS默认滑动阻尼
  noBounce(data: { noBounce: number }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000019',
        data: data,
      });
      resolve();
    });
  },
  // 调用更新用户信息接口
  UpdateUserInfo() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000017',
      });
      resolve();
    });
  },
  // 添加日历提醒
  addCalendarReminders(data: {
    title: string;
    time: string;
    description: string;
  }) {
    return new Promise<boolean>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000031',
        data,
        callback: (data) => {
          console.log(data, '20000031');
          resolve(data?.result || false);
        },
      });
    });
  },
  // 查询日历提醒
  getCalendarReminders(data: { title: string }) {
    return new Promise<boolean>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000032',
        data,
        callback: (data) => {
          console.log(data, '20000032');
          resolve(data?.result || false);
        },
      });
    });
  },
  // 清除缓存
  ClearCache() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000004',
      });
      resolve();
    });
  },
  // 加密json
  EncryptedJsonData(data: any) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000014',
        data: { decryptData: data },
        callback: (data) => {
          resolve(data);
        },
      });
    });
  },
  newSendAliYunCaptcha(data: string, result?: string) {
    return new Promise<boolean>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '30000001',
        data: { captchaVerifyResult: data, result: result || '' },
        callback: (data) => {
          resolve(data?.result || false);
        },
      });
    });
  },
  sendAliYunCaptcha(data: string, result?: string) {
    return new Promise<boolean>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '30000001',
        data: { captchaVerifyResult: data, result: result || '' },
        callback: (data) => {
          resolve(data?.result || false);
        },
      });
    });
  },
  // 解密json
  DecodeJsonData(data: any) {
    return new Promise<void>((resolve) => {
      console.log('发起请求');
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000009',
        data: { encryptData: data },
        callback: (data) => {
          console.log('callback');
          resolve(data);
        },
      });
    });
  },
  // 仅iOS）获取iOS是否正在审核中
  iOSAuditState() {
    if (!isApp()) {
      return Promise.resolve(false);
    }
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000016',
        callback: (data: any) => {
          resolve(data);
        },
      });
    });
  },
};

export function currentSystem() {
  //@ts-ignore
  if (process.server) return '';
  const u = navigator.userAgent;
  const ua = u.toLowerCase();
  let type = '';
  if (/iphone|ipad|ipod/.test(ua)) {
    // iOS 系统 ->  跳AppStore下载地址
    type = 'iOS';
  } else if (/android/.test(ua)) {
    // 安卓系统 -> 跳安卓端下载地址
    type = 'android';
  } else {
    type = 'pc';
  }
  return type;
}
